import { Component, OnInit, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { PlatformLocation } from '@angular/common';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';

@Component({
  selector: 'app-item-details',
  templateUrl: './item-details.component.html',
  styleUrls: ['./item-details.component.scss']
})
export class ItemDetailsComponent implements OnInit {

  allItems: Object;
  itemDetails: Object;
  itemImages: Object;
  itemId: string;
  itemTitle: string;
  itemUrl: string;
  itemLink: string;
  itemType: string;
  itemDescription: string;
  itemThumbnail: string;
  itemDesigner: string;
  itemDesignerUrl: string;
  ecommerceWebsite: string;
  itemLocation: string[] | null = null;
  lat: number | null = null;
  lng: number | null = null;
  totalItems: number;
  postType: string;
  urlTree: any;
  faArrowLeft = faArrowLeft;
  public errorMsg;
  public listId;

  // google maps zoom level
  zoom: number = 12;
  center?: google.maps.LatLngLiteral;
  circleOptions: google.maps.CircleOptions = {
    radius: 5000,
    fillColor: 'red',
    draggable: true,
    editable: true
  };
  mapOptions: google.maps.MapOptions;
  markers: MapMarkerData[] = [];
  selectedMarkerLabel?: string;

  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;

  constructor(public router: Router,
    private titleService: Title, 
    private metaService: Meta, 
    private route: ActivatedRoute, 
    private _http: HttpService,
    private platformLocation: PlatformLocation,
    private location: Location) { }

  ngOnInit(): void {

    this.metaService.addTags([
      {name: 'robots', content: 'index, follow'}
    ]);

    this.mapOptions = {
      disableDefaultUI: false,
      zoomControl: false,
      streetViewControl: false,
      styles: this.styles
    };

    this.itemUrl = this.route.snapshot.paramMap.get("url");
    // console.log(this.itemUrl);
    // console.log(this.route.snapshot.paramMap);
    this.urlTree = this.route.snapshot.paramMap.get("type");
    // console.log(this.urlTree);
    this.itemType = !this.urlTree ? 'all' : this.urlTree;
    this.postType = this.route.snapshot.paramMap.get("postType");
    // console.log(this.postType);

    if(this.postType === 'websites'){
      this._http.getWebsiteDetail(this.itemUrl).subscribe(
        data => {
          this.itemDetails = data;
          // console.log(this.itemDetails);
          this.itemId = this.itemDetails['id'];
          this.itemImages = this.itemDetails['post_images'].split(",");
          this.itemType = this.itemDetails['post_category'];
          this.itemTitle = this.itemDetails['title'];
          this.itemLink = this.itemDetails['site_link'];
          this.itemDescription = this.itemDetails['post_description'];
          this.itemThumbnail = this.itemDetails['thumbnail_image'];
          this.itemDesigner = this.itemDetails['designer'];
          this.itemDesignerUrl = this.itemDetails['designer_url'];
          this.ecommerceWebsite = this.itemDetails['ecommerce_website'];
          this.titleService.setTitle(this.itemDetails['title']);
          this.metaService.updateTag({name: 'keywords', content: this.itemDetails['meta_keywords']});
          this.metaService.updateTag({name: 'description', content: this.itemDetails['meta_description']});
        },
        error => this.errorMsg = error      
      );

      this._http.getWebsites(this.itemType, null).subscribe(
        data => {
          this.allItems = data.length > 4 &&  data.length > 1 ? data.filter((item) => { return item['title'] != this.itemTitle}) : data;
          this.totalItems = data.length;
          // console.log(this.allItems);
        },
        error => {
          return this.errorMsg = error;
        }      
      );

    } else {
      this._http.getPhotoDetail(this.itemUrl).subscribe(
        data => {
          this.itemDetails = data;
          console.log(this.itemDetails);
          this.itemId = this.itemDetails['id'];
          this.itemImages = this.itemDetails['post_images'].split(",");
          this.itemType = this.itemDetails['post_category'];
          this.itemTitle = this.itemDetails['title'];
          this.itemDescription = this.itemDetails['post_description'];
          this.itemThumbnail = this.itemDetails['thumbnail_image'];
          const locationRaw = this.itemDetails['post_location'];
          this.itemLocation = locationRaw ? locationRaw.split(',') : null;
          if (this.itemLocation && this.itemLocation.length === 2) {
            const parsedLat = parseFloat(this.itemLocation[0]);
            const parsedLng = parseFloat(this.itemLocation[1]);
            if (!isNaN(parsedLat) && !isNaN(parsedLng)) {
              this.lat = parsedLat;
              this.lng = parsedLng;
              this.updateMarkers(parsedLat, parsedLng, this.itemTitle);
            }
          }
          this.titleService.setTitle(this.itemDetails['title']);
          this.metaService.updateTag({name: 'keywords', content: this.itemDetails['meta_keywords']});
          this.metaService.updateTag({name: 'description', content: this.itemDetails['meta_description']});
        },
        error => this.errorMsg = error      
      );

      this._http.getPhotos(this.itemType, null).subscribe(
        data => {
          this.allItems = data.length > 4 && data.length > 1? data.filter((item) => { return item['title'] != this.itemTitle}) : data;
          this.totalItems = data.length;
          // console.log(this.totalItems);
          // console.log(this.allItems);
        },
        error => {
          return this.errorMsg = error;
        }      
      );

    }
    
    // console.log(this.itemType);   

  }

  goBack() {
    // this.router.navigate(['../'], {relativeTo: this.route});
    this.location.back();
  }

  updateMarkers(lat: number, lng: number, label?: string) {
    this.center = { lat, lng };
    this.markers = [
	    {
		    position: { lat, lng },
		    label,
		    draggable: false
	    }
    ];
  }

  clickedMarker(label: string | undefined, index: number, marker: MapMarker) {
    this.selectedMarkerLabel = label || index.toString();
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
    console.log(`clicked the marker: ${label || index}`);
  }
  
  mapClicked(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      const position = event.latLng.toJSON();
      this.markers.push({
        position,
        label: `Marker ${this.markers.length + 1}`,
        draggable: false
      });
    }
  }
  
  markerDragEnd(marker: MapMarkerData, event: google.maps.MapMouseEvent) {
    console.log('dragEnd', marker, event);
  }

  styles: any[] =
    [
      {
        "featureType":"landscape.natural",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#dfdfdf"
            }
        ]
      },
      {
        "featureType":"landscape.man_made",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#d7d9d9"
            }
        ]
      },
      {
        "featureType":"road.highway",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#afafaf"
            }
        ]
      },
      {
        "featureType":"road.arterial",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#dedede"
            }
        ]
      },
      {
        "featureType":"road",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#ababab"
            }
        ]
      },
      {
        "featureType":"poi",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#e6e6e6"
            }
        ]
      },
      {
        "featureType":"road.local",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#010404"
            }
        ]
      },
      {
        "featureType":"road.arterial",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#040404"
            }
        ]
      },
      {
        "featureType":"road.highway",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#0f0f01"
            }
        ]
      }
  ]
  
  customOptions: OwlOptions = {    
    dots: false,
    stagePadding: 50,
    loop:true,
    autoplay: true,
    autoHeight:true,
    margin:10,
    nav:true,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 1 
      }
    }
  }

  allSitesOption: OwlOptions = {
    stagePadding: 50,
    loop:true,
    margin:10,
    nav:false,
    navText: ['<', '>'],
    responsive:{
        0:{
            items:2,
            nav:true,
            dots: false,
        },
        600:{
            items:3
        },
        1000:{
            items:5
        }
    }
  }

}

// just an interface for type safety.
interface MapMarkerData {
	position: google.maps.LatLngLiteral;
	label?: string;
	draggable: boolean;
}